import Request from 'request';

export default {
    listTreeSelectEvent: async () => {
        try {
            const res = await Request.get('/rule/event_list', {});

            return {
                data: res.data,
                count: res.totalCount
            };
        } catch (err) {
            console.error(err);
        }
    }
};
